"use client";
import { useEffect } from "react";
import AOS from "aos";
import "../css/globals.css";
import "aos/dist/aos.css";
import LandingPageHeader from "../../components/ui/header";
import { Kanit } from "next/font/google";
import { cn } from "@/lib/utils";

const font = Kanit({
  weight: "600",
  subsets: ["latin"],
});

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
      animatedClassName: "aos-animate",
    });
    window.addEventListener("load", () => {
      AOS.refresh();
    });
  }, []);

  return (
    <body
      className={cn(
        `antialiased bg-white text-text-landing h-screen overflow-hidden`,
        font.className
      )}
    >
      <div>
        <LandingPageHeader />
        <div className="flex flex-col h-screen overflow-y-auto pt-[36px] justify-between">
          <main className="items-center justify-center grow">{children}</main>
          {/* <LandingPageFooter /> */}
        </div>
      </div>
    </body>
  );
}
